export default "__VITE_ASSET__091396eb__"